module.exports = __webpack_public_path__ + "img/EDO.e7b1da2e.svg";